import { apiGet, apiPost, apiPostForm, apiPut, apiGetBlob } from "./apiClient";

export function getTransactionSchedules(params = {}) {
    const searchParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
            searchParams.append(key, value);
        }
    });

    const query = searchParams.toString();
    return apiGet(`/transaction-schedules${query ? `?${query}` : ""}`);
}

export function getTransactionScheduleDatas(params = {}) {
    const searchParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
            searchParams.append(key, value);
        }
    });

    const query = searchParams.toString();
    return apiGet(`/transaction-schedules${query ? `?${query}` : ""}`);
}

export function createTransactionSchedule(payload) {
    return apiPost("/transaction-schedules", payload);
}

export function previewTransactionScheduleExcel(file) {
    const formData = new FormData();
    formData.append("file", file);
    return apiPostForm("/transaction-schedules/preview", formData);
}

export function uploadTransactionScheduleExcel(file) {
    const formData = new FormData();
    formData.append("file", file);
    return apiPostForm("/transaction-schedules/upload", formData);
}

export function getTransactionScheduleManageDetail(id) {
    return apiGet(`/transaction-schedules/${id}/manage`);
}

export function saveTransactionScheduleManageDetail(id, payload) {
    return apiPut(`/transaction-schedules/${id}/manage`, payload);
}

export function getTransactionScheduleAllocationStatusLogs(id) {
    return apiGet(`/transaction-schedules/${id}/allocation-status-logs`);
}

export function getTransactionScheduleStatusLogs(id) {
    return apiGet(`/transaction-schedules/${id}/status-logs`);
}

export function getInstitutions() {
    return apiGet("/institutions");
}

export function getTransactionScheduleBankOptionsByInstitution(institutionId, currency) {
    const params = new URLSearchParams();
    params.append("institutionId", institutionId);

    if (currency) {
        params.append("currency", currency);
    }

    return apiGet(`/transaction-schedules/bank-options/by-institution?${params.toString()}`);
}

export function agreeTransactionScheduleAllocation(allocationId) {
    return apiPut(`/transaction-schedules/allocations/${allocationId}/agree`);
}

export function unagreeTransactionScheduleAllocation(allocationId) {
    return apiPut(`/transaction-schedules/allocations/${allocationId}/unagree`);
}

export function getReturns() {
    return apiGet("/transaction-allocation-checker/returns");
}

export function runAllTransactionAllocationChecks() {
    return apiPost("/transaction-allocation-checker/run", {});
}

export function runTransactionAllocationCheck(allocationId) {
    return apiPost(`/transaction-allocation-checker/allocations/${allocationId}/run`, {});
}

export function getReturnAllocationOptions(statementId, query = "") {
    const encoded = encodeURIComponent(query || "");
    return apiGet(`/transaction-allocation-checker/returns/allocation-options?statementId=${statementId}&query=${encoded}`);
}

export function confirmDetectedReturn(statementId, payload) {
    return apiPost(`/transaction-allocation-checker/returns/${statementId}/confirm`, payload);
}

export function getReturnHistory() {
    return apiGet("/transaction-allocation-checker/returns/history");
}

export function deleteTransactionSchedule(id) {
    return apiPost(`/transaction-schedules/${id}/delete`, {});
}

export function getTransactionScheduleUnagreedReservations(id, institutionId, currency) {
    const params = new URLSearchParams();
    params.append("institutionId", institutionId);

    if (currency) {
        params.append("currency", currency);
    }

    return apiGet(`/transaction-schedules/${id}/unagreed-reservations?${params.toString()}`);
}

export function getIgnoredReturns() {
    return apiGet("/transaction-allocation-checker/returns/ignored");
}

export function ignoreDetectedReturn(statementId, payload = {}) {
    return apiPost(`/transaction-allocation-checker/returns/${statementId}/ignore`, payload);
}

export function restoreIgnoredReturn(statementId) {
    return apiPost(`/transaction-allocation-checker/returns/${statementId}/restore`, {});
}

export function bulkManageSchedules(payload) {
    return apiPost("/transaction-schedules/bulk-manage", payload);
}

export function bulkAgreeSingleSchedules(ids) {
    return apiPost("/transaction-schedules/bulk-agree-single", { ids });
}

export function downloadTransactionScheduleInvoice(id) {
    return apiGetBlob(`/transaction-schedules/${id}/invoice`);
}

export function downloadTransactionScheduleContract(id) {
    return apiGetBlob(`/transaction-schedules/${id}/contract`);
}

export function uploadTransactionScheduleInvoice(id, file) {
    const formData = new FormData();
    formData.append("file", file);
    return apiPostForm(`/transaction-schedules/${id}/invoice`, formData);
}

export function uploadTransactionScheduleContract(id, file) {
    const formData = new FormData();
    formData.append("file", file);
    return apiPostForm(`/transaction-schedules/${id}/contract`, formData);
}

export function downloadGeneratedAllocationSlipPdf(allocationId) {
    return apiGetBlob(`/transaction-schedules/allocations/${allocationId}/generated-slip-pdf`);
}

export function downloadGeneratedAllocationSampleFilledPdf(allocationId) {
    return apiGetBlob(`/transaction-schedules/allocations/${allocationId}/generated-sample-filled-pdf`);
}

export function uploadScannedLatestSlipPdf(allocationId, file) {
    const formData = new FormData();
    formData.append("file", file);
    return apiPostForm(`/transaction-schedules/allocations/${allocationId}/scanned-latest-slip-pdf`, formData);
}

export function uploadScannedLatestSampleFilledPdf(allocationId, file) {
    const formData = new FormData();
    formData.append("file", file);
    return apiPostForm(`/transaction-schedules/allocations/${allocationId}/scanned-latest-sample-filled-pdf`, formData);
}

export function downloadScannedLatestSlipPdf(allocationId) {
    return apiGetBlob(`/transaction-schedules/allocations/${allocationId}/scanned-latest-slip-pdf`);
}

export function downloadScannedLatestSampleFilledPdf(allocationId) {
    return apiGetBlob(`/transaction-schedules/allocations/${allocationId}/scanned-latest-sample-filled-pdf`);
}


export function getUnsortedExpenses() {
    return apiGet("/expense-sorting/unsorted");
}

export function confirmExpenseSort(statementId, payload) {
    return apiPost(`/expense-sorting/${statementId}/confirm`, payload);
}

export function revertExpenseSort(statementId) {
    return apiPost(`/expense-sorting/${statementId}/revert`, {});
}

export function getSortedExpenseHistory() {
    return apiGet("/expense-sorting/history");
}

export function ignoreExpense(statementId) {
    return apiPost(`/expense-sorting/${statementId}/ignore`, {});
}

export function restoreIgnoredExpense(statementId) {
    return apiPost(`/expense-sorting/${statementId}/restore`, {});
}

export function getIgnoredExpenses() {
    return apiGet("/expense-sorting/ignored");
}

export function getReturnedSchedules() {
    return apiGet('/transaction-schedules/returned');
}